// Anchors infinite CSS animations to a fixed wall-clock epoch so every
// gold LoRRI-agent element across the app (regardless of which component
// renders it or when it mounts) stays phase-locked in sync.
const SHINE_EPOCH = Date.UTC(2024, 0, 1);

const getSyncedAnimationDelay = (durationSeconds) => {
  const elapsedSeconds = (Date.now() - SHINE_EPOCH) / 1000;
  const offset = elapsedSeconds % durationSeconds;
  return `-${offset.toFixed(3)}s`;
};

export const SHINE_ANIMATION_DELAY = getSyncedAnimationDelay(2.8);
export const PULSE_ANIMATION_DELAY = getSyncedAnimationDelay(2.2);
